import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { CardLabel, FormStep, RadioOrSelect, TextInput, SubmitBar } from "@egovernments/digit-ui-react-components";

const LocationDetails = ({ config, onSelect, formData }) => {
  const { t } = useTranslation();
  let currCity = JSON.parse(sessionStorage.getItem("currentCity")) || { };
  let currPincode = sessionStorage.getItem("currentPincode");
  let currLocality = JSON.parse(sessionStorage.getItem("currentLocality")) || { };
  const allDistricts=Digit.SessionStorage.get("CITIZEN.COMMON.HOME.DIST")
  const { pathname: url } = useLocation();
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const stateId = Digit.ULBService.getStateId();
  const [isOpen, setIsOpen] = useState(false);
  const [selectedCity, setSelectedCity] = useState(allDistricts?.name);
  const [villageIndex, setVillageIndex] = useState(null)
  const [localities, setLocalities] = useState(allDistricts?.boundary || []);
  const [selectedLocality, setSelectedLocality] = useState(formData?.address?.locality || null);
  const [villages, setVillages] = useState([])
  const [village, setVillage] = useState(formData?.address?.children || null)
  const [villageOpen, setOpenVillage] = useState(false)
  const [areaType, setAreaType] = useState("")
  formData = { address: { ...formData?.address } };
  const code = allDistricts?.code || 'hp';
  // const tcpCode = code.includes("tcp")
  // const udCode = code.includes("ud")
  const applicationFlow = Digit?.SessionStorage.get("CITIZEN.COMMON.HOME.FLOW") || null;
  const tcpCode = applicationFlow === 'TCP';
  const udCode = applicationFlow === 'UD';

  const handleSubmit = () => {
    const address = { }
    address.city = selectedCity;
    address.tenantId = code;
    address.locality = selectedLocality?.name || "";
    address.areaType = areaType;
    address.village = village?.name || "";
    address.doorNo = selectedLocality?.name || null
    onSelect(config.key, address);
  };

  function selectCity(city) {
    setSelectedLocality(null);
    setLocalities(null);
    setSelectedCity(city);
    sessionStorage.setItem("currentCity", JSON.stringify(city));
    formData.address["city"] = city;
  }

  function selectLocality(locality) {
    if (formData?.address?.locality) {
      formData.address["locality"] = locality;
    }
    const boundaryIndex = localities.findIndex((e) => e.name === locality.name)
    setVillageIndex(boundaryIndex)
    setSelectedLocality(locality);
    setVillages(localities?.[boundaryIndex]?.children)
    setOpenVillage(true)
    setAreaType(localities?.[boundaryIndex]?.IsSpecialArea === true ? `Special Area` : `Planning Area`)
    sessionStorage.setItem("currLocality", JSON.stringify(locality));
  }

  function selectVillage(village) {
    if (formData?.address?.village) {
      formData.address["village"] = village;
    }
    setVillage(village)
    sessionStorage.setItem("currVillage", JSON.stringify(village));

  }

  return (
    <div style={{marginLeft:"13px"}}>
    {!isOpen && <FormStep
      t={t}
      onSelect={handleSubmit}
      isDisabled={!selectedCity || !selectedLocality}
      isMultipleAllow={true}
      cardStyle={{boxShadow: 'none', padding: 0, border: 0}}
      // forcedError={t(Pinerror)}
    >
          <CardLabel>{`${t("BPA_DISTRICT_LABEL")}*`}</CardLabel>
      {!isOpen && <TextInput        
        t={t}
        type={"text"}
        isMandatory={false}
        optionKey="i18nKey"
        name="district"
        value={selectedCity}
        onChange={selectCity}
        disabled={true}
      />}
      {!isOpen && selectedCity && tcpCode && (
        <span className={"form-pt-dropdown-only"}>
          <CardLabel>{`${t("BPA_LOC_NOTIFIED-AREA_LABEL")}*`}</CardLabel>
          <RadioOrSelect
            optionCardStyles={{ maxHeight:"20vmax", overflow:"scroll" }}
            isMandatory={config.isMandatory}
            options={localities.sort((a, b) => a.name.localeCompare(b.name))}
            optionKey="name"
            onSelect={selectLocality}
            t={t}
            isDependent={true}
            isDropDown={true}
          />
        </span>
      )}
      {!isOpen && selectedCity && udCode && (
        <span className={"form-pt-dropdown-only"}>
          <CardLabel>{`${t("BPA_ULB-AREA_LABEL")}*`}</CardLabel>
          <RadioOrSelect
            optionCardStyles={{ maxHeight:"20vmax", overflow:"scroll" }}
            isMandatory={config.isMandatory}
            options={localities.sort((a, b) => a.name.localeCompare(b.name))}
            optionKey="name"
            onSelect={selectLocality}
            t={t}
            isDependent={true}
            isDropDown={true}
          />
        </span>
      )}
      {!isOpen && selectedCity && villageOpen && tcpCode && (
        <div>
          <CardLabel>{`${t("BPA_AREA_TYPE_LABEL")}`}</CardLabel><TextInput
            t={t}
            type={"text"}
            optionKey="i18nKey"
            name="district"
            value={areaType}
            disabled={true} />
        </div>
      )}
      
       {!isOpen && selectedCity && villageOpen && tcpCode && (
        <span className={"form-pt-dropdown-only"}>
          <CardLabel>{`${t("BPA_LOC_VILLAGE-AREA_LABEL")}`}</CardLabel>
          <RadioOrSelect
            optionCardStyles={{ maxHeight:"20vmax", overflow:"scroll" }}
            isMandatory={config.isMandatory}
            options={villages.sort((a, b) => a.name.localeCompare(b.name))}
            optionKey="name"
            onSelect={selectVillage}
            t={t}
            isDependent={true}
            isDropDown={true}
          />
        </span>
      )}

      {!isOpen && selectedCity && villageOpen && udCode && (
        <span className={"form-pt-dropdown-only"}>
          <CardLabel>{`${t("BPA_LOC_WARD-AREA_LABEL")}`}</CardLabel>
          <RadioOrSelect
            optionCardStyles={{ maxHeight:"20vmax", overflow:"scroll" }}
            isMandatory={config.isMandatory}
            options={villages.sort((a, b) => a.name.localeCompare(b.name))}
            optionKey="name"
            onSelect={selectVillage}
            t={t}
            isDependent={true}
            isDropDown={true}
          />
        </span>
      )}
    <SubmitBar label={t(`CS_COMMON_NEXT`)} onSubmit={handleSubmit} style={{marginTop: '1rem'}} />
    </FormStep>}
    </div>
  );
};

export default LocationDetails;